import React, { useEffect } from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { getToken } from '../../services/TokenStorage';

/**
 * Conecta no WS de notificações da app. Antes mostrava um toast a cada
 * erro de WS — isso era spammy porque a lib reconecta a cada 3s, e
 * cada falha disparava um toast. Hoje a sinalização visual fica a cargo
 * do ConnectionBanner (via onStateChange).
 *
 * props:
 * - onMessage(msg) — payload sem `notification`
 * - onNotification(notif) — payload com `notification` (toasts vindos do backend)
 * - onStateChange(readyState) — opcional, recebe o ReadyState pra UI exibir status
 */
function AppWebSocket(props) {

    const { lastJsonMessage, readyState } = useWebSocket(process.env.REACT_APP_WS_URL, {
        onOpen: () => {
            // eslint-disable-next-line no-console
            console.log('Connected to App WS');
        },
        onMessage: () => {
            if (!lastJsonMessage) return;

            if (lastJsonMessage.notification && props.onNotification)
                props.onNotification(lastJsonMessage.notification);
            else if (props.onMessage)
                props.onMessage(lastJsonMessage);
        },
        queryParams: { 'token': getToken() },
        // Silenciado por design — o ConnectionBanner sinaliza o problema
        // de conexão de forma agregada (sem spam de toast).
        onError: () => {},
        shouldReconnect: () => true,
        reconnectInterval: 3000
    });

    useEffect(() => {
        if (props.onStateChange) props.onStateChange(readyState);
    }, [readyState, props]);

    return (
        <React.Fragment></React.Fragment>
    );
}

export { ReadyState };
export default AppWebSocket;
